"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuV2Submenu = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_menu_v2_constants_1 = require("./bc-menu-v2-constants");
var BcMenuV2Submenu = (function () {
    function BcMenuV2Submenu(mySelf, configHeaderMegaMenu) {
        this.configHeaderMegaMenu = configHeaderMegaMenu;
        this.mySelf = mySelf;
        this.render();
    }
    BcMenuV2Submenu.prototype.render = function () {
        this.createSubmenu();
    };
    BcMenuV2Submenu.prototype.createSubmenu = function () {
        var _this = this;
        var elementsMenuMenus = this.mySelf.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        elementsMenuMenus.forEach(function (subMenu) {
            var subGroups = subMenu.querySelector(common_constants_1.BcCommonConstants.UL_TAG);
            var containerSubMenu = subMenu.insertBefore(_this.createElementHtml(common_constants_1.BcCommonConstants.SECTION_TAG), subMenu.firstChild);
            containerSubMenu.setAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DATA_TOOGLE, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOOGLE);
            var divElement = _this.createElementHtml(common_constants_1.BcCommonConstants.DIV_TAG);
            var subMenuItem = containerSubMenu.insertBefore(divElement, containerSubMenu.firstChild);
            divElement.setAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DATA_TOOGLE, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOOGLE);
            _this.configHeaderMegaMenu(subMenu, subMenuItem, false, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ICON_PREMIUM, true, subMenuItem);
            if (subGroups) {
                var emElement = _this.createElementHtml(common_constants_1.BcCommonConstants.EM_TAG);
                var arrowRight = containerSubMenu.appendChild(emElement);
                arrowRight.setAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DATA_TOOGLE, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOOGLE);
                emElement.setAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DATA_TOOGLE, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOOGLE);
                arrowRight.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_XS_CLASS);
                arrowRight.innerText = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ICON_ARROW_RIGHT;
                arrowRight.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_LABEL);
            }
        });
    };
    BcMenuV2Submenu.prototype.createElementHtml = function (element) {
        return document.createElement(element);
    };
    return BcMenuV2Submenu;
}());
exports.BcMenuV2Submenu = BcMenuV2Submenu;
